import { ISubscriber } from '../teacher';

export interface IPrayerTime {
	id: number;
	day: number;
	month: string;
	IqamatFajr: string;
	Fajr: string;
	Sonnenaufgang: string;
	Dhuhr: string;
	Asr: string;
	Maghrib: string;
	Isha: string;
	IqamatJomaa_1: string;
	IqamatJomaa_2: string;
	IqamatJomaa_3: string | null;
}

export interface ITranslation {
	id: number;
	locale: string;
	name: string;
	description: string;
	body: string;
}

export interface INews {
	id: number;
	name: string;
	description: string;
	body: string;
	thumb: string;
	main_img: string;
	thumb_de: string;
	main_img_de: string;
	date: string;
	ord: number;
	status: number;
	home: number;
	created_at: string;
	translations: ITranslation;
}

export interface IAd {
	id: number;
	name: string;
	description: string;
	body: string;
	thumb: string;
	main_img: string;
	thumb_de: string;
	main_img_de: string;
	date: string;
	ord: number;
	status: number;
	created_at: string;
}

export interface IActivity {
	id: number;
	type: number;
	name: string;
	description: string;
	body: string;
	joins: number;
	thumb: string;
	payment: number;
	date: string;
	ord: number;
	status: number;
	created_at: string;
	main_img: string;
	thumb_de: string;
	main_img_de: string;
}

export interface IHome {
	prayerTimes: IPrayerTime;
	news: INews[];
	ads: IAd[];
	activities: IActivity[];
}

export interface IFaq {
	id: number;
	name: string;
	body: string;
	ord: number;
	created: string;
	status: boolean;
	translations: {
		id: number;
		locale: string;
		name: string;
		body: string;
	};
}

export interface IPath {
	id: number;
	name: string;
	body?: string;
	img?: string;
	isChild: boolean;
	isMan: boolean;
	translations?: ITranslation[];
}
export interface IPathLevel {
	[key: number]: {
		parent: string;
		child: {
			'30': string;
			'31': string;
		};
	};
}
export interface IHomeSchool {
	id: number;
	name: string;
	address?: string;
	city?: string;
	location?: string;
	phone?: string;
	body?: string;
	email?: string;
	translations?: ITranslation[];
	disabled?: boolean;
	is_small_age?: boolean;
}
export interface IProgramTeacher {
	id: number;
	name: string;
	lname: string;
	gender: string;
	photo: string;
	available: number;
}
export interface IProgramTeacherTimes {
	id: number;
	seminar_id: number;
	day: string;
	from_to: string;
	available: number;
	fee: number;
	subscribe_type: number;
	max_joins: number;
	type: number;
	one_time_reg_fee: number;
	language: string;
	program_id?: number;
}

export interface IProgram {
	id: number;
	name: string;
	body: string;
	from_date: string;
	to_date: string;
	subscribe_cost: number;
	one_time_reg_fee: number;
	level: string;
	subscribe_cost_per_month: number;
	count: number;
	translations?: ITranslation[];
	type?: number;
	edupath_id: number;
}

export interface ICoupon {
	academic_year_id: number;
	code: string;
	coupon_group_id: number;
	created_at: string;
	discount: number;
	expired_at: string;
	id: number;
	korani_user_id: number;
	name: string;
	subscriber_id: number;
	subscriber_seminar_id: number;
	type: number;
	used: number;
	uses: number;
}

export interface IProgramPaymentWay {
	payments_count: number;
	payment: number;
	id: number;
	name: string;
}

export enum INotificationTypeEnum {
	HOMEWORK = 'Homework',
	CONTENT = 'Content',
	NOTE = 'Note',
	TEST = 'Test',
}

export interface ISubscriberNotification {
	id: number;
	type: INotificationTypeEnum;
	created_at: string;
	subscriber: Pick<ISubscriber, 'id' | 'name' | 'lname'>;
}

export interface INotifications {
	id: number;
	title: string;
	body: string;
	url: string | null;
	img: string | null;
	created_at: string;
	sent: 0 | 1; // kommt bei dir als 1/0
	sent_at: string | null;
	_locale: string; // z. B. "en"
}

export interface INotificationsResponse {
	subscriberNotifications: ISubscriberNotification[];
	notifications: INotifications[];
}
